const storage = {
    not_configured: 'Depolama sağlayıcısı yapılandırılmamış.',
    missing_parameter: 'Depolama sağlayıcısı için eksik parametre {{parameter}}.',
    upload_error: 'Dosya yüklenemedi.',
    download_error: 'Failed to download file from the storage provider.',
};
export default Object.freeze(storage);
